// import { version } from 'react';

const siteConfig = {
	siteName: 'Zezamii',
	footerText: 'Zezamii Pty Ltd. - ' + process.env.REACT_APP_ENV,
	enableAnimatedRoute: false,
	mainServerBaseDomain: '', // base url for the main Backend server.
	// Function to get the correct domain based on environment
	getApplicationServerBaseDomain: (environment) => {
		switch (environment) {
			case 'development':
				return 'dev.api.zezamii.com';
			case 'staging':
				return 'dev.api.zezamii.com';
			case 'production':
			default:
				return 'df.api.zezamii.com';
		}
	},
	// Keeping static property for backward compatibility
	applicationServerBaseDomain: 'df.api.zezamii.com', //WIP - DO NOT INCLUDE HTTP:// OR HTTPS:// IN THE URL. e.g.value "dte.com "
	google: {
		analyticsKey: 'UA-xxxxxxxxx-1'
	},
	dashboard: '/access',
	version: '3.1.1'
};
export default siteConfig;
